import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';

import IconDataOrange from '../../assets/images/common/icon-data-orange.svg';
import IconLibraryWhite from '../../assets/images/common/icon-library-white.svg';
import IconMailWihte from '../../assets/images/common/icon-mail-wihte.svg';
import ArrowRightBlue from '../../assets/images/common/arrow-right-blue.svg';

import { SearchApiResponse } from '../../types/api/SearchApiType';

import { SearchTextField } from '../../components/SearchTextField';

type SearchBodyProps = {
    setOpenTutorialModal: (value: boolean) => void;
    searchResult: SearchApiResponse;
};

// 間隔調整用の半角スペース
const HARF_SPACE = ' ';

export const SearchBody: React.FC<SearchBodyProps> = ({ setOpenTutorialModal, searchResult }) => {
    return (
        <>
            <section className='section top-kv'>
                <div className='container'>
                    <div className='columns'>
                        <div className='column is-6'>
                            <h1 className='top-title'>
                                <ruby>
                                    第三者保守<rt>（EOSL延長保守）</rt>
                                </ruby>
                                {HARF_SPACE}対応機種検索
                            </h1>
                            <p className='top-discription'>
                                ストレージ、ネットワーク、サーバーの各機器の名称から検索し、保守レベル・保守期間等を指定した概算価格の見積もりをご依頼できます。
                            </p>
                            <p className='top-search_discription'>※メーカー名は不要です。</p>
                            <SearchTextField
                                inputClassName={'input is-large is-top_search'}
                                buttonClassName={'button is-dl_gra is-large'}
                            />
                            <p className='top-search_discription'>
                                （Cisco スイッチを検索の方は Catalyst と入力ください。候補が出ます）
                            </p>
                        </div>
                        <div className='column is-5 is-offset-1'>
                            <div className='kv'>
                                <div className='kv-data_spec'>
                                    <span className='icon'>
                                        <img src={IconDataOrange} alt='' />
                                    </span>
                                    <p className='kv-data_spec--text'>只今対応可能な機種数</p>
                                    <p className='kv-data_spec--num'>
                                        <span className='count'>
                                            <CountUp end={searchResult.count} />
                                        </span>
                                    </p>
                                </div>
                                <div className='kv-tutorial' onClick={() => setOpenTutorialModal(true)}>
                                    <a className='js-modal-trigger' data-target='modal-first'>
                                        <div className='kv-tutorial--text'>
                                            簡単な説明を見る
                                            <img src={ArrowRightBlue} alt='' />
                                        </div>
                                        <div className='kv-tutorial--icon'>
                                            <img src={IconLibraryWhite} alt='' />
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='columns top-inquiry'>
                        <div className='column is-9-desktop is-12-mobile is-12-tablet'>
                            <div className='top-inquiry_wrapper'>
                                <p>
                                    複数の設置場所がある場合や、機器リストのファイル添付したい方、
                                    <br />
                                    機器検索ができない方などはこちらよりお問い合わせください。
                                </p>
                                <Link to='/contact/topPage' className='button is-primary'>
                                    <span>一括見積依頼、お問い合わせはこちら</span>
                                    <span className='icon'>
                                        <img src={IconMailWihte} alt='' />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
